import styles from './ccf-preview-image.module.scss';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPreviewImgPathData } from '../ccf-interaction-workspace/ccf-interaction-space.slice';

/* eslint-disable-next-line */
export interface CcfPreviewImageProps {
  imgIndex: any;
  isOpen: boolean;
}

/**
 * function  to render Icon For GuidancceScore
 * @param param0 - param
 * @example renderIconForGuidancceScore()
 * @returns
 */
export function CcfPreviewImage(props: CcfPreviewImageProps) {
  const [photoIndex, setphotoIndex] = useState(props.imgIndex);
  const [isOpen, SetisOpen] = useState(props.isOpen);
  const history = useHistory();
  const imagesPath = useSelector(getPreviewImgPathData);

  /**
   * function  to render Icon For GuidancceScore
   * @param param0 - param
   * @example renderIconForGuidancceScore()
   * @returns
   */
  function closePreview() {
    history.push('/home');
    SetisOpen(false);
  }

  return (
    <div>
      {isOpen && (
        <Lightbox
          mainSrc={
            imagesPath[photoIndex].includes('pdf')
              ? './../assets/liam-reimbursement.png'
              : './../assets/broken-luggage.png'
          }
          nextSrc={imagesPath[(photoIndex + 1) % imagesPath.length]}
          prevSrc={
            imagesPath[(photoIndex + imagesPath.length - 1) % imagesPath.length]
          }
          onCloseRequest={() => closePreview()}
          onMovePrevRequest={() =>
            setphotoIndex(
              (photoIndex + imagesPath.length - 1) % imagesPath.length
            )
          }
          onMoveNextRequest={() =>
            setphotoIndex((photoIndex + 1) % imagesPath.length)
          }
        />
      )}
    </div>
  );
}

export default CcfPreviewImage;
